import { useAppSelector } from '@/redux/hooks'
import classnames from 'classnames/bind'

// Components
import { StateHandler } from '@/components/pages/livemallclub/Explore/components/Preferences/components/SearchResults/components/_shared/StateHandler'
import ProductList from '@/components/shared/livemallclub/LivePreview/ProductList'

// Libs
import useMemberProductsQuery, { MemberTimelineProductResponseType } from '../../../hooks/useMemberProductsQuery'
import { useProfileData } from '../../../hooks/useProfileData'
import { useProfileContext } from '../../../reducer'

// Constants
import { PRODUCT_STATUS } from '@/constants/livemallclub/productStatus'
import { ROLE_TYPE } from '@/constants/roleType'
import { ProductListData } from '@/hooks/useLiveRoomProduct'
import { MemberTimelineProductFeedType } from '../../../hooks/useMemberProductsQuery'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const formatProductList = (rawList: MemberTimelineProductResponseType[]): ProductListData[] => {
  if (rawList.length === 0) return []

  const flatList = rawList
    .flatMap((item) => item)
    .flatMap((item) => item.feeds)
    .filter((item) => !!item)
  if (flatList.length === 0) return []
  return flatList.map((item) => {
    return {
      sort: 0,
      productInfo: (item as MemberTimelineProductFeedType).productMeta,
      isDel: false,
      isTop: false,
      sortName: '',
    }
  })
}

const MemberShop = () => {
  const { memberIdToQuery } = useProfileData()
  const { isManageMode } = useProfileContext().state
  const { memberData } = useAppSelector((state) => state.member)
  const isMerchantOwnProfile = memberData.memberInfoId === memberIdToQuery && memberData.roles?.includes(ROLE_TYPE.MERCHANT)

  const { data: rawProductList, query, InfiniteScrollComponent } = useMemberProductsQuery({ memberInfoId: memberIdToQuery })
  const productList = formatProductList(rawProductList)
  const displayedProductList: ProductListData[] =
    isMerchantOwnProfile && !isManageMode ? productList.filter((product) => product.productInfo.status === PRODUCT_STATUS.ON_SHELF) : productList
  const isEmpty = displayedProductList.length === 0 || displayedProductList.every((item) => !item.productInfo)

  return (
    <StateHandler isFetching={query.isLoading} isEmpty={isEmpty} type='profile_shop' position='absolute'>
      <InfiniteScrollComponent>
        <div className={cx('member-shop')}>
          <ProductList productList={displayedProductList} bgColor='grey' discountTagLayout='inline' showVisibilityMask={isManageMode} />
        </div>
      </InfiniteScrollComponent>
    </StateHandler>
  )
}

export default MemberShop
